import { render, staticRenderFns } from "./p6.vue?vue&type=template&id=6242c04f&scoped=true&"
import script from "./p6.vue?vue&type=script&lang=js&"
export * from "./p6.vue?vue&type=script&lang=js&"
import style0 from "./p6.vue?vue&type=style&index=0&id=6242c04f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6242c04f",
  null
  
)

export default component.exports